<template>
  <Banner text="<span style='font-weight:800'>Coming soon!</span> The Mysteries of Tosola, our new game comes out on August 29!" @updateBannerState="onBannerUpdate" color="green" :force-state="initBannerState"></Banner>
  <nav id="main-nav" v-if="!isCompact" :class="navClasses">
    <div class="standard">
      <div class="container-large standard-container">
        <router-link to="/home" class="no-hover no-pd">
        <SVGLogoLight v-if="color==='teal'" size="desktop"></SVGLogoLight>
        <SVGLogoDark v-else size="desktop"></SVGLogoDark>
      </router-link>
        <div class="row">
          <div class="submenu-parent">
             <a @click="submenuOpenClose()" >Interactive Stories</a>
              <div class="submenu col" v-if="submenuOpen">
                <router-link :to="{ path: '/tbwttnl' }">The Bear Who Touched The Northern Lights</router-link>
                <router-link :to="{ path: '/tosola' }">The Mysteries Of Tosola</router-link>
              </div>
          </div>
          <router-link :to="{ path: '/events'}" >Events & Workshops</router-link>
           <router-link :to="{ path: '/retailers'}" >Retailers</router-link>
          <router-link :to="{ path: '/shop'}" >Shop</router-link>
<!--          <router-link :to="{ path: '/home', hash: '#about' }" >About Us</router-link>-->
      </div>
      </div>
    </div>
  </nav>
  <nav v-show="isCompact" class="mobile" id="nav-mobile" :class="navClasses">
    <div class="container-large row">
        <router-link to="/" class="logo-link no-hover">
        <SVGLogoLight v-if="color==='teal'" size="mobile"></SVGLogoLight>
        <SVGLogoDark v-else size="mobile"></SVGLogoDark>
      </router-link>
      <img :src="require('../assets/img/' + imageHamburgerMenuSrc)" alt="menu icon" @click="triggerMobileMenu(true)">
    </div>
  </nav>
  <nav :class="{active : mobileMenu}" class="mobile-open" id="menu-full-open">
    <div class="container-large">
      <img src="../assets/img/icon-close.svg" alt="close menu icon" @click="triggerMobileMenu(false)">
      <div class="links">
        <a @click="triggerMobileMenu(false)">Interactive Stories</a>
        <div class="submenu-mobile col">
          <div class="row">
            <span class="secondary-link-line"></span><router-link :to="{ path: '/tbwttnl' }" class="secondary-link">The Bear Who Touched The Northern Lights</router-link>
          </div>
          <div class="row">
            <span class="secondary-link-line"></span> <router-link :to="{ path: '/tosola' }" class="secondary-link">The Mysteries Of Tosola</router-link>
          </div>
        </div>
        <router-link :to="{ path: '/'}" @click="triggerMobileMenu(false)">Events & Workshops</router-link>
        <router-link :to="{ path: '/retailers'}" @click="triggerMobileMenu(false)">Retailers</router-link>
        <router-link :to="{ path: '/shop'}" @click="triggerMobileMenu(false)">Shop</router-link>
<!--        <router-link :to="{ path: '/home', hash: '#about' }" @click="triggerMobileMenu(false)">About Us</router-link>-->
      </div>
    </div>
  </nav>
</template>

<script>
import SVGLogoLight from "@/components/SVGLogoLight";
import SVGLogoDark from "@/components/SVGLogoDark";
import Banner from "@/components/Banner";

export default {
  name: 'Nav',
  props: ['color', 'initBannerState'],
  components: {
    SVGLogoLight,
    SVGLogoDark,
    Banner
  },
  data() {
    return {
      isCompact: false,
      isMobile: false,
      mobileMenu: false,
      prevScroll: 0,
      hamburgerMenu: {
        teal: 'icon-menu_teal.svg',
        blue: 'icon-menu_blue.svg'
      },
      onScroll: false,
      submenuOpen: false
    }
  },
  methods: {
    submenuOpenClose() {
      this.submenuOpen = !this.submenuOpen;
    },
    resizeHandler() {
      this.isCompact = window.innerWidth < 1068;
      this.isMobile = window.innerWidth < 769;
    },
    triggerMobileMenu(state) {
      this.mobileMenu = state;
    },
    onBannerUpdate(state) {
      this.isBannerOpened = state;
      let navElt = this.getNavElt();
      if (!state) {
        navElt.classList.remove("banner-offset");
        navElt.style.top =  '0';
      } else {
        navElt.classList.add("banner-offset");
      }
    },
    getNavElt(){
      var navElt;
      if (this.isCompact) {
        navElt = document.getElementById("nav-mobile");
      } else {
        navElt = document.getElementById("main-nav");
      }
      return navElt;
    },
    handleScroll() {
      var currentScrollPos = window.scrollY;
      var navElt = this.getNavElt();

      if (currentScrollPos < navElt.clientHeight + (this.isBannerOpened ? 20 : 0)){
        navElt.classList.remove("onScroll");
        this.onScroll = false;
        navElt.style.position = 'absolute';
        if (this.isBannerOpened) {
          navElt.style.top = this.bannerOffset;
        } else {
          navElt.style.top =  '0px';
        }
      } else {
        if (this.prevScroll > currentScrollPos) {
          navElt.style.top = this.bannerOffset;
          navElt.style.position = "fixed";
          navElt.classList.add("onScroll");
          this.onScroll = true;
        } else {
          navElt.style.top = "-150px";
          navElt.classList.remove("onScroll");
          this.onScroll = false;
        }
      }
      this.prevScroll = currentScrollPos;
    }
  },
  mounted() {
    this.isCompact = window.innerWidth < 1068;
    this.isMobile = window.innerWidth < 769;
    window.addEventListener("resize", this.resizeHandler);
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  computed:{
    isBannerOpened() {
      return this.$store.getters.getBannerState && this.initBannerState;
    },
    imageHamburgerMenuSrc() {
      if (this.color === 'teal') {
        return this.hamburgerMenu.teal;
      } else {
        return this.hamburgerMenu.blue;
      }
    },
    navClasses() {
      return {
        'banner-offset': this.isBannerOpened,
        'blue': this.color === 'blue',
        'teal': this.color === 'teal',
        'bg-teal' : this.color === 'blue' & this.onScroll,
        'bg-blue' : this.color === 'teal' & this.onScroll,
      }
    },
    bannerOffset() {
      if (this.isBannerOpened){
        if (this.isCompact || this.isMobile) {
          return "40px"
        } else {
          return "38px";
        }
      } else {
        return "0";
      }
    },

  },
  watch: {
    mobileMenu(newState) {
      if (newState) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "scroll";
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables.scss';


svg {
  &#logo {
    width: 60px;
    padding-top: 20px;
    padding-bottom: 20px;

    &.mobile {
      width: 50px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}

nav {
  width: 100%;
  //transition: top 0.2s, background-color .2s;

  &#main-nav {
    top: 0;
    padding-top: 0;
    position: absolute;
    z-index: 998;

    &.banner-offset {
      top : 33px;
    }
  }



  .standard-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    z-index: 999;
  }

  &.onScroll, &.transit {
    a, button {
      color: $light-blue;
      &:hover, &.router-link-active {
        color: $teal;
      }
    }
    .standard {
      border-bottom: 1px solid $blue-hover;

      svg#logo {
        transition: 1ms ease-in-out all;
        width: 40px;
        padding-top: 10px;
        padding-bottom: 5px;
      }
    }

    &.mobile {
      border-bottom: 1px solid $blue-hover;
    }

    a.arrow::after, button.arrow::after {
      border-left: 1px solid $light-blue;
      border-bottom: 1px solid $light-blue;
    }

    a.arrow:hover::after, button.arrow:hover::after {
      border-left: 1px solid $teal;
      border-bottom: 1px solid $teal;
    }
  }
}

nav {

  &.blue {
    a, button, p {
       color: $blue;
      &:hover, &.router-link-active, &.active  {
        color: $blue;
        &::after {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 7.5px;
          background-color: $blue;
          position: absolute;
          right: -15px;
          top: calc(50% - 5px);
        }
      }
    }
  }

  &.cream {
    a, button, p {
       color: $blue;
      &:hover, &.router-link-active, &.active  {
        color: $blue;
        &::after {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 7.5px;
          background-color: $blue;
          position: absolute;
          right: -15px;
          top: calc(50% - 5px);
        }
      }
    }
  }

  &.teal {
    a, button, p {
      color: $teal;
      position: relative;
      &:hover, &.router-link-active, &.active {
        color: $teal;
        &::after {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 7.5px;
          background-color: $teal;
          position: absolute;
          right: -15px;
          top: calc(50% - 5px);
        }
      }
    }
  }

  a, button, p {
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 500;
    line-height: 18.7px;
    margin: .2em 0 .2em 3em;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    padding: 0;
    background-color: transparent;
    border-radius: 0;
    position: relative;

    &:hover, &.router-link-active {
      cursor: pointer;
    }
  }

  a.no-hover, button.no-hover {
    &:hover {
      &::after {
        display: none;
      }
    }
    &.router-link-active {
      &::after {
        display: none;
      }
    }
  }

  a.no-pd {
    padding: 0;
    margin: 0;
  }
}

.submenu-parent {
  position: relative;
}

.submenu {
  min-width: 420px;
  position: absolute;
  top: 2.5em;
  left: 0;
  background-color: $cream;

  border-top: 1px $teal solid;
  border-bottom: 1px $teal solid;
  padding: 1.5em 4em 1.5em 0em;
  gap: 1em;
  margin-left: 1em;

  a {
    margin-left: 2em;
    width: fit-content;
  }
}

nav.mobile {
  position: fixed;
  padding: .5em 0px;
  z-index: 900;

  &.onScroll {
    svg#logo {
      width: 40px;
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
  //transition: top 0.3s;

  .row {
    justify-content: space-between;
    align-items: center;
  }

  &.banner-offset {
    top : 40px;
  }

  img {
    max-width: 25px;
    max-height: 25px;
    cursor: pointer;
  }

  svg {
    width: 100px;
  }

  a {
    margin: 0;
  }

  a.logo-link {
    max-width: 50px;
    width: 100%;
  }
}

nav.mobile-open.active {
  transform: translateY(0);
  opacity: 1;
  //transition: all .5s ease-in-out;
}

img {
  &.background-hero {
    position: absolute;
    width: 100%;
    top: 0;
  }

  &.sea-hero {
    position: absolute;
    width: 100%;
    top: 68vh;
  }
}

a.arrow::after, button.arrow::after {
  content: "";
  width: 7px;
  margin-left: 7px;
  height: 7px;
  display: inline-block;
  border-left: 1px solid $font-dark;
  border-bottom: 1px solid $font-dark;
  transform: translateY(-2px) rotate(-45deg);
}

a.arrow:hover::after, button.arrow:hover::after {
  border-left: 1px solid $blue;
  border-bottom: 1px solid $blue;
}

//nav, nav.onScroll {
//  #product-dropdown {
//    position: absolute;
//    display: none;
//    a {
//      font-size: 1em;
//      color: $blue;
//      text-decoration: none;
//      border-bottom: none;
//
//      &:hover {
//        text-decoration: none;
//        border: none;
//      }
//    }
//
//    &.visible {
//      top: 25px;
//      left: -100px;
//      display: flex;
//      flex-direction: column;
//      width: max-content;
//      text-align: left;
//      border-radius: 15px;
//      background-color: $teal;
//      filter: drop-shadow(-2px 4px 4px rgba(0, 0, 0, 0.15));
//      a:first-child {
//        border-radius: 15px 15px 0 0;
//      }
//
//      a:last-child {
//        border-radius: 0px 0px 15px 15px;
//      }
//
//      a {
//        padding: 15px;
//        margin: 0;
//        &:hover {
//          background-color: $teal-hover;
//          color: $light-blue;
//        }
//
//        &.router-link-active {
//          border-bottom: 2px solid transparent;
//        }
//      }
//    }
//  }
//}
.secondary-link-line {
  width: 2em;
  margin-top: 1em;
  border-top: 1px solid $teal;
  margin-left: 1.7em;
}

#menu-full-open {
  height: 100vh;
  display: none;

  &.active {
    display: block;
  }

  .container-large {
    height: 100%;

    .links {
      height: 100%;
      justify-content: center;
      display: flex;
      flex-direction: column;

      a, p {
        margin-left: 1em;
        font-size: 1.6em;
        font-weight: 700;
        color: $cream;
        line-height: 1.5em;

        &.secondary-link {
          font-weight: 400;
          font-size: 1.1em;
          width: calc(100% - 5em);
        }
      }
    }

    img {
      position: absolute;
      top: 2em;
      right: 0;
      width: 30px;
      cursor: pointer;
    }
  }
}

nav.mobile-open {
  transform: translateY(-500px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: $blue;
  z-index: 999;
  opacity: 0;
}



</style>